import { useCallback, useEffect, useState } from 'react';
import { sentryClient, setupSentryClient } from './sentry-client';
export const useTeamsSentryClientSetup = (isSentryEnabled, config) => {
  const [sentryInitialised, setSentryInitialised] = useState(false);
  const setupSentry = useCallback(async () => {
    if (!sentryInitialised && isSentryEnabled && !sentryClient) {
      await setupSentryClient(config);
    }
  }, [config, isSentryEnabled, sentryInitialised]);
  useEffect(() => {
    setupSentry().then(() => setSentryInitialised(true));
  }, [setupSentry]);
  return sentryClient;
};